module.exports = __webpack_public_path__ + "static/media/elsight.5c4efe40.png";